import React from "react";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import { formatIdBultoSkim } from "../../../../helpers/formatValues";
import {
    RenderKilogramo,
    RenderNumber,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";
import { ActionBtn } from "../../../../../../Utils/Buttons/ActionBtn";
const emptyIcon = require("assets/img/icons/empty-icon.png");

export const BultosTable = ({ bultos, DescartarBultoSkim, totales = {} }) => {
    return (
        <div className="new-table-wrapper mt-3">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Almacén</th>
                        <th>Peso original</th>
                        <th>Peso restante</th>
                        <th>Peso utilizado</th>
                        <th>DRC</th>
                        <th>Kg secos restantes</th>
                        <th>Descartar</th>
                    </tr>
                </thead>
                <tbody>
                    {bultos.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No hay bultos de skim cargados
                            </td>
                        </tr>
                    )}
                    {bultos.map((bulto) => (
                        <tr key={bulto.id}>
                            <td className="text-center text-nowrap">
                                {formatIdBultoSkim(bulto)}
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue value={bulto.almacen}>
                                    {bulto.almacen && bulto.almacen.nombre}
                                </NullableValue>
                            </td>
                            <td className="text-center">
                                <RenderNumber
                                    value={bulto.kg_humedos_original}
                                    decimalScale={2}
                                />
                            </td>
                            <td className="text-center">
                                <RenderNumber
                                    value={bulto.kg_humedos_actual}
                                    decimalScale={2}
                                />
                            </td>
                            <td className="text-center">
                                <RenderNumber
                                    value={
                                        parseFloat(bulto.kg_humedos_original) -
                                        parseFloat(bulto.kg_humedos_actual)
                                    }
                                    decimalScale={2}
                                />
                            </td>
                            <td className="text-center text-nowrap">
                                {bulto.drc ? (
                                    <RenderNumberPercentage
                                        value={bulto.drc}
                                        decimalScale={3}
                                    />
                                ) : (
                                    "Pendiente"
                                )}
                            </td>
                            <td className="text-center">
                                <NullableValue value={bulto.kg_secos_actual}>
                                    <RenderNumber
                                        value={bulto.kg_secos_actual}
                                        decimalScale={2}
                                    />
                                </NullableValue>
                            </td>
                            <td>
                                <div className="table-actions">
                                    <ActionBtn
                                        imgSource={emptyIcon}
                                        title="Descartar"
                                        btnColor="#F44336"
                                        onClick={() =>
                                            DescartarBultoSkim(bulto)
                                        }
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr className="totales-row">
                        <td colSpan={3} className="text-right">
                            <strong>Totales:</strong>
                        </td>
                        <td className="text-center text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_humedos_restantes || 0}
                                decimals={3}
                            />
                        </td>
                        <td className="text-center text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_humedos_utilizados || 0}
                                decimals={3}
                            />
                        </td>
                        <td></td>
                        <td className="text-center text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_secos_restantes || 0}
                                decimals={3}
                            />
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
